import { render, staticRenderFns } from "./_base-page-subtitle.vue?vue&type=template&id=43c6d302&scoped=true&"
import script from "./_base-page-subtitle.vue?vue&type=script&lang=js&"
export * from "./_base-page-subtitle.vue?vue&type=script&lang=js&"
import style0 from "./_base-page-subtitle.vue?vue&type=style&index=0&id=43c6d302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c6d302",
  null
  
)

export default component.exports